<div>
  <div class="groups">
    @for (blok of body(); track blok._uid) {
      <div>
        <p [class.selected]="blok.title === selected" (click)="selected = blok.title">{{blok.title}}</p>
      </div>
    }
  </div>
  @for (blok of body(); track blok._uid) {
    @for (item of blok.body; track item) {
      @if (blok.title === selected) {
        <div class="row">
          @if (components) {
            <ng-template [ngComponentOutlet]="components[item.component]" [ndcDynamicInputs]="item">
            </ng-template>
          }
        </div>
      }
    }
  }
</div>
